import { useUpdateAuthorityMutation } from '@/graphql/types';

export default function (authority: { id: string; name: string; cvr: string; isActive: boolean }) {
  const mutation = useUpdateAuthorityMutation({});

  function call() {
    return mutation.mutate({
      input: {
        id: authority.id,
        name: authority.name,
        cvr: authority.cvr,
        isActive: authority.isActive
      }
    });
  }

  return {
    ...mutation,
    call
  };
}
